import apiClient from './apiClient';

export const walletService = {
  getBalance: () => apiClient.get('/wallet/balance').then((res) => res.data),
  getTopUps: () => apiClient.get('/wallet/top-ups').then((res) => res.data),
  /** Without params: full list (wallet widget). With page/limit: paginated. */
  getTickets: (params) =>
    apiClient
      .get('/wallet/tickets', { params: params || undefined })
      .then((res) => res.data),
};
